import { useNavigate } from "react-router-dom";
import styles from "./main.module.scss";
import { ReactComponent as Logo } from "../../svgs/cipm-logobig-e1650631957250 4.svg";

import { ReactComponent as BackIcon } from "../../svgs/back.svg"
import { ReactComponent as ErrorImage } from "../../svgs/back.svg";
import Buttons from "@mui/material/Button";
import { useContext } from "react";
import { NotificationContext } from "../../provider/notification";
import { useAtom } from "jotai";
import { userAtom } from "../../utils/store";
const Error404 = () => {
  const navigate = useNavigate();
  const [user, setUser] = useAtom(userAtom);

  const handleNavigate = () => {
     // eslint-disable-next-line
    if (user?.UserName && user?.Token)
    navigate("/overview");
    else navigate('/')
  };
  return (
    <>
      <section className={styles.section}>
        <div className={styles.logo}>
          <Logo className={styles.logoStyle} />
        </div>
        <div className={styles.formWrapper}>
          <p className={styles.header}>Sorry this page isn’t available.</p>
        </div>
        <div className={styles.errorWrapper}>
          <div>
            <p className={styles.errortype}>
              <span className={styles.four}>4</span>
              <span className={styles.zero}>0</span>
              <span className={styles.four}>4</span>
            </p>
          </div>
        </div>

        <div className={styles.formWrapper}>
          <Buttons
            onClick={handleNavigate}
            className={styles.button}
            variant="outlined"
            startIcon={<BackIcon className={styles.backicon} />}
          >
            Back to Overview
          </Buttons>
        </div>
      </section>
    </>
  );
};
export default Error404;
